<ng-container *ngIf="stepInput.isBulkEdit">
  <div style="width: 75%">
    <app-items-for-bulk-edit
      [selectedItems]="stepInput.selectedLineItem"
      entityType="line_item"
      step="day_part"
      [dspType]="stepInput.dsp"
      [isBulkEdit]=true
    >
    </app-items-for-bulk-edit>
  </div>
</ng-container>

<ng-container *ngIf="stepInput.dsp == 'vdsp'">
  <mat-form-field
    class="li_input_field me-2"
    appearance="outline"
    floatLabel="always"
    [hideRequiredMarker]="false"
  >
    <mat-label>Timezone</mat-label>
    <mat-icon matSuffix>search</mat-icon>
    <mat-select
      disableOptionCentering
      required
      [(ngModel)]="daypart_timezone"
      (openedChange)="triggerEvent($event)"
      (selectionChange)="proceed()"
      placeholder="Choose One"
      [multiple]="false"
    >
      <mat-option>
        <ngx-mat-select-search
          (keyup)="searchTimeZone($event.target.value)"
          [placeholderLabel]="'search timezone...'"
          [noEntriesFoundLabel]="'Not found'"
        >
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let timeZone of timeZoneOptions" [value]="timeZone">
        {{ timeZone }}
      </mat-option>
    </mat-select>
    <mat-error> Please select Timezone </mat-error>
  </mat-form-field>
</ng-container>

<div
  [ngClass]="{
    day_part_action: true,
    'justify-content-start': stepInput.dsp == 'adsp' || stepInput.dsp == 'tdsp' ,
    'flex-column': stepInput.isBulkEdit
  }"
>
  <div class="d-flex justify-content-between">
    <ng-container *ngIf="stepInput.isBulkEdit && stepInput.dsp == 'adsp'">
      <div class="mt-3">
        <span class="field-name">Operation:</span>
        <mat-radio-group [(ngModel)]="bulkEditTrgtAct.user_time_of_week">
          <mat-radio-button
            class="ms-2"
            *ngFor="let item of trgtOperations"
            [value]="item.value"
            [matTooltip]="item.toolTip"
          >
            {{ item.label }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </ng-container>
  
    <button
      type="button"
      (click)="clearDayPart()"
      mat-button
      *ngIf="
        !stepInput.isBulkEdit ||
        bulkEditTrgtAct.user_time_of_week != 'remove_all'
      "
      class="action_btn_no-border mb-3"
    >
      Clear All
    </button>
  </div>
  <p
    [ngClass]="{ 'ms-5': !stepInput.isBulkEdit }"
    *ngIf="stepInput.dsp == 'adsp' || stepInput.dsp == 'tdsp'"
    class="warning_message tooltip-class flex_box"
  >
    Ads will be delivered in the timeslots selected below based on user Time
    zone. Ads will be delivered 24x7 if no timeslots are selected.
  </p>
</div>

<div
  class="dayPart_container"
  *ngIf="
    !stepInput.isBulkEdit || bulkEditTrgtAct.user_time_of_week != 'remove_all'
  "
>
  <div class="list_container" style="padding: 0em 1em 0em 0em">
    <table class="split_table">
      <thead>
        <tr>
          <th class="">
            <div class="table-heading">
              <label class="day-name">All Days </label>
            </div>
          </th>
          <th>
            <div class="table-heading" (click)="selectDay('monday')">
              <label class="day-name">Monday </label>
            </div>
          </th>
          <th>
            <div class="table-heading" (click)="selectDay('tuesday')">
              <label class="day-name">Tuesday </label>
            </div>
          </th>
          <th>
            <div class="table-heading" (click)="selectDay('wednesday')">
              <label class="day-name">Wednesday </label>
            </div>
          </th>
          <th>
            <div class="table-heading" (click)="selectDay('thursday')">
              <label class="day-name">Thursday </label>
            </div>
          </th>
          <th>
            <div class="table-heading" (click)="selectDay('friday')">
              <label class="day-name">Friday </label>
            </div>
          </th>
          <th>
            <div class="table-heading" (click)="selectDay('saturday')">
              <label class="day-name">Saturday </label>
            </div>
          </th>
          <th>
            <div class="table-heading" (click)="selectDay('sunday')">
              <label class="day-name">Sunday </label>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of hourArray; let i = index">
          <td (click)="selectTimeForEntireWeek(i)" class="table-heading">
            <span *ngIf="checkDigit(item)"> 0 </span>
            <span>
              {{ item }}:00 <span> {{ i <= 11 ? " AM" : " PM" }} -</span></span
            >
            <span *ngIf="checkDigit(item + 1)" class="ms-1"> 0 </span>
            <span [ngClass]="!checkDigit(item + 1) ? 'ms-1' : ''">
              {{ item + 1 == 13 ? "1" : item + 1 }}:00<span>
                {{ i < 11 || i == 23 ? " AM" : " PM" }}
              </span>
            </span>
          </td>
          <td
            class="split_table_row"
            [ngClass]="{ select_cells: week['monday'].indexOf(i) >= 0 }"

            (mousedown)="onMouseDown('monday', i)"
            (mouseenter)="onMouseEnter('monday', i)"
            (mouseup)="onMouseUp()"
          ></td>
          <td
            class="split_table_row"
            [ngClass]="{ select_cells: week['tuesday'].indexOf(i) >= 0 }"

            (mousedown)="onMouseDown('tuesday', i)"
            (mouseenter)="onMouseEnter('tuesday', i)"
            (mouseup)="onMouseUp()"
          ></td>
          <td
            class="split_table_row"
            [ngClass]="{ select_cells: week['wednesday'].indexOf(i) >= 0 }"

            (mousedown)="onMouseDown('wednesday', i)"
            (mouseenter)="onMouseEnter('wednesday', i)"
            (mouseup)="onMouseUp()"
          ></td>
          <td
            class="split_table_row"
            [ngClass]="{ select_cells: week['thursday'].indexOf(i) >= 0 }"

            (mousedown)="onMouseDown('thursday', i)"
            (mouseenter)="onMouseEnter('thursday', i)"
            (mouseup)="onMouseUp()"
          ></td>
          <td
            class="split_table_row"
            [ngClass]="{ select_cells: week['friday'].indexOf(i) >= 0 }"

            (mousedown)="onMouseDown('friday', i)"
            (mouseenter)="onMouseEnter('friday', i)"
            (mouseup)="onMouseUp()"
          ></td>
          <td
            class="split_table_row"
            [ngClass]="{ select_cells: week['saturday'].indexOf(i) >= 0 }"

            (mousedown)="onMouseDown('saturday', i)"
            (mouseenter)="onMouseEnter('saturday', i)"
            (mouseup)="onMouseUp()"
          ></td>
          <td
            class="split_table_row"
            [ngClass]="{ select_cells: week['sunday'].indexOf(i) >= 0 }"

            (mousedown)="onMouseDown('sunday', i)"
            (mouseenter)="onMouseEnter('sunday', i)"
            (mouseup)="onMouseUp()"
          ></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
